import type { AddProviderFormValues } from "@/components/Forms/AddEditProviderDialog.tsx";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useAddProviderToCase = (
    caseUUID: string,
): UseMutationResult<void, Error, AddProviderFormValues> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (attributes) => {
            const response = await fetch(apiUrl("/party/provider/create"), {
                method: "PUT",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    caseUUID,
                    ...attributes,
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["case-parties-table-data", caseUUID],
            });
            await queryClient.invalidateQueries({
                queryKey: ["disbursement", caseUUID],
            });
        },
    });
};
